/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ValidatorFn } from '@angular/forms';
import {
  AppFormControl,
  ApplicationStateHolder, ControlSchemaPackedValue,
  ControlSchemaType,
  FormControlSchema,
  FormControlSchemaConfig,
} from '@gh/common-shared';
import { Type } from '@gh/core-type';
import { isNil } from 'lodash';
import { AbstractBuilderControlSchema } from './abstract-builder-control-schema';

export function ensureControlSchema(stateHolder: ApplicationStateHolder, child: any): AbstractBuilderControlSchema {
  if (child instanceof AbstractBuilderControlSchema) {
    return child;
  } else {
    const schema = new BuilderFormControlSchema(stateHolder);
    schema.update(child || {});
    return schema;
  }
}

export class BuilderFormControlSchema extends AbstractBuilderControlSchema implements FormControlSchema {
  schemaType = ControlSchemaType.Leaf;

  type?: Type<any>;

  constructor(stateHolder: ApplicationStateHolder) {
    super(stateHolder);
  }

  update(config: FormControlSchemaConfig): void {
    super.update(config);

    this.type = isNil(config.type) ? this.type : config.type;
  }

  applyTo(control: AppFormControl, packedValue?: ControlSchemaPackedValue): void {
    super.applyTo(control);

    control.type = this.type;
    if (packedValue && control.value !== packedValue.value) {
      control.setValue(packedValue.value);
    }
  }

  build(value?: any): AppFormControl {
    const control = new AppFormControl(
      this, {
        value,
        disabled: !this.isEnabled(),
      },
      this.buildValidators(),
      this.asyncValidators);

    control.required = this.isRequired();
    control.visible = this.isVisible();
    control.privilegedEntryPoint = this.privilegedEntryPoint;
    control.lastValidators = this.validators;
    control.lastAsyncValidators = this.asyncValidators;
    control.type = this.type;

    return control;
  }

  protected isUpdateValidators(control: AppFormControl): boolean {
    return control.type !== this.type;
  }

  protected buildValidators(): ValidatorFn[] {
    return super.buildValidators().concat(isNil(this.type) ? [] : [this.type.validator]);
  }
}
